import React from 'react'
import useCards from '../../../hooks/useCards'

const CuidadosCards = () => {
  const { homeinCards } = useCards()
  
  return (
      <>
          {homeinCards(14)}

      </>
  )
} 

export default CuidadosCards